import { useCustomEvent } from 'custom_events/queries/detail'
import { EventChangesScreenProps } from 'home/stack/types'
import { StatusBoundary } from 'shared/components/status_boundary'
import { EventChangesView } from './view'

export function EventChangesScreen({
  navigation,
  route,
}: EventChangesScreenProps) {
  const customEventQuery = useCustomEvent(
    {
      id: route.params?.customEventId,
    },
    !!route.params?.customEventId
  )

  return (
    <StatusBoundary
      isLoading={customEventQuery.isLoading}
      error={customEventQuery.error}
    >
      <EventChangesView event={customEventQuery.data} />
    </StatusBoundary>
  )
}
